/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ProductDtoBase } from "./ProductDtoBase";
import { TextureMaterialDto } from "./TextureMaterialDto";

export class CladdingProductDto extends ProductDtoBase {
    claddingTextureMaterialId: string | null;
    claddingTextureMaterial: TextureMaterialDto;
}
